// Google Places "types" buckets that are too generic to use as a business
// keyword/category. Selecting a business and auto-filling the keyword with one
// of these produced "establishment" in the GBP-audit form and seeded grid/
// competitor searches with a meaningless term (DIG-129).
export const GENERIC_PLACE_TYPES = ['establishment', 'point of interest', 'premise', 'business', 'geocode'];

export function isGenericType(type) {
  const normalized = String(type == null ? '' : type).replace(/_/g, ' ').trim().toLowerCase();
  return normalized === '' || GENERIC_PLACE_TYPES.indexOf(normalized) !== -1;
}

// Return the first non-generic Google "type" (underscores normalized to spaces),
// or '' when the listing only has generic buckets — in which case the caller
// should leave the keyword blank for the user to fill rather than guess.
export function firstMeaningfulType(types) {
  if (!Array.isArray(types)) return '';
  for (let i = 0; i < types.length; i++) {
    if (isGenericType(types[i])) continue;
    return String(types[i]).replace(/_/g, ' ').trim();
  }
  return '';
}
